import { render } from "./sidebar-menu.vue?vue&type=template&id=a225c67a"
import script from "./sidebar-menu.vue?vue&type=script&lang=js"
export * from "./sidebar-menu.vue?vue&type=script&lang=js"

import "./sidebar-menu.vue?vue&type=style&index=0&id=a225c67a&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__